'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const Header = () => {
  const pathname = usePathname();

  return (
    <header className="w-full bg-white border-b border-[#E8E2D8] relative z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">

        {/* LOGO */}
        <Link href="/" className="flex items-center gap-3 group">
          <div className="w-7 h-7 flex items-center justify-center transform group-hover:-translate-y-0.5 transition-all duration-300">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8C7B6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </div>
          <span className="text-[#1A1614] font-light text-sm tracking-[0.15em] uppercase" style={{ fontFamily: 'Inter, sans-serif' }}>
            Conjugador Interactivo
          </span>
        </Link>

        {/* NAVIGATION */}
        <nav className="hidden md:flex items-center gap-8">
          <Link
            href="/drill-configuration"
            className={`text-xs font-medium uppercase tracking-[0.12em] transition-colors duration-200 ${
              pathname === '/drill-configuration' ? 'text-[#1A1614]' : 'text-[#6B6259] hover:text-[#1A1614]'
            }`}
          >
            Configuración
          </Link>
          <Link
            href="/exercise-interface"
            className={`text-xs font-medium uppercase tracking-[0.12em] transition-colors duration-200 ${
              pathname === '/exercise-interface' ? 'text-[#1A1614]' : 'text-[#6B6259] hover:text-[#1A1614]'
            }`}
          >
            Ejercicio
          </Link>
        </nav>

      </div>
    </header>
  );
};

export default Header;